import { render, staticRenderFns } from "./LeadAssignDialog.vue?vue&type=template&id=1a16c68a"
import script from "./LeadAssignDialog.vue?vue&type=script&lang=ts"
export * from "./LeadAssignDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports